/**
 * Checks if two timestamps are of the same day or not
 *
 * @export
 * @param {Number|String} t1
 * @param {Number|String} t2
 * @returns
 */
export default function (t1, t2) {
    const d1 = new Date(parseInt(t1)), d2 = new Date(parseInt(t2))
	return d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
}
